import dataConfigs from '@/project/data/index.js'
import { SerializerFactory } from './internal/serializers/serializerFactory.js'

export function registerAllSerializers() {
  Object.values(dataConfigs.serializers).forEach(Serializer => {
    SerializerFactory.register(new Serializer())
  })
}
